import { render, staticRenderFns } from "./ProfessionalInformation.vue?vue&type=template&id=d9660f28&scoped=true"
import script from "./ProfessionalInformation.vue?vue&type=script&lang=ts"
export * from "./ProfessionalInformation.vue?vue&type=script&lang=ts"
import style0 from "./ProfessionalInformation.vue?vue&type=style&index=0&id=d9660f28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9660f28",
  null
  
)

export default component.exports